import { Element } from '@thive/canvas';
import { Areas, FlowStop } from '@thive/fddm-types';

import { filterAreasByIds } from '@/modules/floorplanDesign/helpers';
import { elementFactory } from '@/modules/canvas/factories';
import { FDDM_TAG } from '@/modules/floorplanDesign/constants';
import { areasToFlatCollection } from '@/modules/floorplanDesign/helpers/helpers';
import { getAreaColorByArea, modifyColor } from '@/modules/floorplanDesign/mappers/colors';
import { createPaddedBoundingBoxRectangle } from './mapperHelpers';
import { computeRectanglesBoundingBoxExtent } from '@/modules/common/helpers/boundingBox';
import { RectangleUtils } from '@/modules/floorplanDesign/helpers/RectangleUtils';

export const flowStopMapper = (flowStops: FlowStop[], allAreas: Areas): Element[] =>
  flowStops.flatMap((flowStop) => {
    const areasInFlowStop = filterAreasByIds(allAreas, flowStop.areaIds);
    const areas = areasToFlatCollection(areasInFlowStop);
    if (areas.length === 0) return [];
    const boundingBox = computeRectanglesBoundingBoxExtent(
      RectangleUtils.convertAreasToRectangles(areasInFlowStop),
    );

    const strokeColor = modifyColor(getAreaColorByArea(areas[0]), false, '80');

    return [
      elementFactory.buildRectangleElement({
        id: flowStop.id,
        z: 0,
        interactivity: {
          draggable: false,
          rotatable: false,
          scalable: false,
          selectable: false,
          snappable: false,
          clickable: true,
        },
        rectangle: createPaddedBoundingBoxRectangle(boundingBox, 0.2),
        color: '#00000000',
        stroke: {
          color: strokeColor,
          width: 50,
        },
        tags: [FDDM_TAG.FLOW_STOP],
      }),
    ];
  });
